import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import fileDownload from 'js-file-download'
import { Layout, PlotData } from 'plotly.js'

import { getExportReport } from '../../api/analytics'
import { getFilename } from '../../utils/fileDownload'
import PageHeader from '../PageHeader/PageHeader'
import { onDateChange } from '../Shared/DateRangeInput/DateRangeInput'

import AnalyticsContent from './AnalyticsContent/AnalyticsContent'
import AnalyticsDataAggregation from './AnalyticsDataAggregation/AnalyticsDataAggregation'

import styles from './analytics.module.scss'

export interface IAnalyticsData {
    data: PlotData[]
    layout: Partial<Layout>
}

function Analytics() {
    const { t } = useTranslation()
    const [aggregationType, setAggregationType] = useState('day')
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')

    const params = new URLSearchParams({
        aggregation_type: aggregationType,
    })

    if (dateFrom) {
        params.append('date_from', dateFrom)
    }
    if (dateTo) {
        params.append('date_to', dateTo)
    }

    const handleExportReport = async () => {
        try {
            const response = await getExportReport(new AbortController(), {
                date_from: dateFrom || undefined,
                date_to: dateTo || undefined,
            })
            const filename = getFilename(response) || 'conversation_export.xlsx'
            fileDownload(response.data, filename)
        } catch (error) {
            console.error('Error exporting report:', error)
        }
    }

    return (
        <div className={styles.analytics}>
            <PageHeader
                title={t('analytics')}
                className={styles.analytics__header}
            >
                <AnalyticsDataAggregation
                    aggregationType={aggregationType}
                    onAggregationChange={setAggregationType}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    onDateChange={onDateChange(setDateFrom, setDateTo)}
                    onExportReport={handleExportReport}
                />
            </PageHeader>
            <main className={styles.analytics__main}>
                <AnalyticsContent params={params} />
            </main>
        </div>
    )
}

export default Analytics
